/* After the page settles, quietly finish loading the page's lazy images at
   low network priority so scrolling doesn't reveal empty slots. Native
   loading="lazy" stays in the markup as the fallback for anyone who scrolls
   faster than the prefetch. Skips data-constrained connections and images
   that aren't laid out (zoom modals, closed drawers) — the product modal's
   full-res images must never be fetched in the background. */
(function () {
  var connection = navigator.connection;
  if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

  var BATCH_SIZE = 6;

  function nextBatch() {
    var batch = Array.prototype.slice
      .call(document.querySelectorAll('img[loading="lazy"]'))
      .filter(function (img) {
        if (img.closest('product-modal, dialog, [hidden]')) return false;
        return img.getBoundingClientRect().width > 0;
      })
      .slice(0, BATCH_SIZE);
    if (!batch.length) return;

    var settled = batch.map(function (img) {
      img.setAttribute('fetchpriority', 'low');
      img.loading = 'eager';
      if (img.complete) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });

    // One batch at a time so the prefetch never saturates the connection.
    Promise.all(settled).then(schedule);
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(nextBatch, { timeout: 2000 });
    } else {
      setTimeout(nextBatch, 300);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', function () {
      setTimeout(schedule, 500);
    }, { once: true });
  }
})();
